<template>
  <div class="empty-container">
    <div v-if="loading">
      <div v-loading="true" class="loading"></div>
    </div>
    <div v-else class="empty-image">
      <svg-icon iconClass="empty"></svg-icon>
    </div>
    <p class="empty-description">{{ textTips }}</p>
  </div>
</template>

<script type="text/javascript">
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    textTips() {
      return this.loading ? '' : this.$t('advertiserSelector.text')
    }
  },
  data() {
    return {}
  },
  mounted() {}
}
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.empty-container {
  text-align: center;
  padding: 50px 0;
  .loading {
    height: 100px;
  }
  .svg-icon {
    width: 64px;
    height: 64px;
    color: rgba(0, 0, 0, 0.25);
  }
  .empty-description {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.25);
  }
}
</style>
